import * as universal_hooks from '../../../src/hooks.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50')
];

export const server_loads = [];

export const dictionary = {
		"/(kiosk)": [48,[15]],
		"/(admin)/audits/authentications": [16,[2]],
		"/(admin)/audits/navigations": [17,[2]],
		"/(admin)/audits/registrations": [18,[2]],
		"/auth/callback": [50],
		"/(admin)/chat": [19,[2]],
		"/(admin)/dashboard": [20,[2]],
		"/(admin)/document-generation-jobs": [21,[2]],
		"/(admin)/employee-parking-companies": [22,[2]],
		"/(admin)/employee-parking-companies/[id]": [23,[2,3]],
		"/(admin)/employee-parking-companies/[id]/configurations/[configurationId]": [24,[2,3]],
		"/(admin)/events": [25,[2]],
		"/(admin)/events/create": [27,[2]],
		"/(admin)/events/[id]": [26,[2,4]],
		"/(anonymous)/invoices/[token]": [45,[11,12]],
		"/(admin)/kiosk-monitoring": [28,[2]],
		"/(admin)/kiosks": [29,[2]],
		"/(admin)/kiosks/create": [31,[2]],
		"/(admin)/kiosks/[id]": [30,[2,5]],
		"/(kiosk)/maintenance": [49,[15]],
		"/(admin)/online-orders": [32,[2]],
		"/(admin)/online-orders/[id]": [33,[2,6]],
		"/(admin)/parking-lots": [34,[2]],
		"/(admin)/parking-lots/[id]": [35,[2,7]],
		"/(admin)/parking-service-companies": [36,[2]],
		"/(admin)/parking-service-companies/create": [38,[2]],
		"/(admin)/parking-service-companies/[id]": [37,[2,8]],
		"/(anonymous)/service-parking/reception/[id]": [46,[11,13]],
		"/(anonymous)/service-parking/redeem/[token]": [47,[11,14]],
		"/(admin)/settings": [39,[2]],
		"/(admin)/transactions": [40,[2]],
		"/(admin)/transactions/[id]": [41,[2,9]],
		"/(admin)/vehicle-types": [42,[2]],
		"/(admin)/vehicle-types/create": [44,[2]],
		"/(admin)/vehicle-types/[id]": [43,[2,10]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: universal_hooks.reroute || (() => {}),
	transport: universal_hooks.transport || {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';